module.exports = __webpack_public_path__ + "img/Medical History.f0d48e6e.png";